var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 13,
    rx: 14,
    ry: 13,
    fill: "url(#paint0_linear_18_2)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.38379,
    y: 5.74026,
    width: 17.5897,
    height: 14.5195,
    fill: "url(#pattern0_18_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2",
    x: 0,
    y: 0,
    width: 36,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_18_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18_2",
    transform: "matrix(0.0078125 0 0 0.00946452 0 -0.105729)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2C23"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18_2",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/botIcon.dea745ce8f1aa93bafb8d5b56cf44009.svg";
export { ForwardRef as ReactComponent };